export const LocalTranslations: { [key: string]: { [key: string]: string } } = {
  "de": {
    "errorCause0": "Wir haben bereits eine Rückmeldung erhalten.",
    "errorCause1": "Der Link zur Umfrage ist abgelaufen.",
    "errorCause2": "Der Link wurde verändert und ist dadurch ungültig geworden.",
    "errorContent": "Leider konnten wir Ihr Feedback nicht entgegennehmen. Das kann mehrere Gründe haben:",
    "header": "Vielen Dank für Ihre Rückmeldung!",
    "success": "Ihr Feedback hilft uns dabei, unseren Service zu verbessern."
  },
  "en": {
    "errorCause0": "We have already received feedback.",
    "errorCause1": "The link to the survey has expired.",
    "errorCause2": "The link has been changed and has become invalid.",
    "errorContent": "Unfortunately, we could not receive your feedback. There may be several reasons for this:",
    "header": "Thank you very much for your feedback!",
    "success": "Your feedback helps us to improve our service."
  },
  "fr": {
    "errorCause0": "Nous avons déjà reçu des commentaires.",
    "errorCause1": "L'hyperlien vers l'enquête a expiré.",
    "errorCause2": "L'hyperlien a été modifié et est devenu invalide.",
    "errorContent": "Malheureusement, nous n'avons pas pu recevoir vos commentaires. Il peut y avoir plusieurs raisons à cela :",
    "header": "Merci beaucoup pour vos commentaires !",
    "success": "Vos commentaires nous aident à améliorer notre service."
  },
  "it": {
    "errorCause0": "Abbiamo già ricevuto feedback.",
    "errorCause1": "Il link al sondaggio è scaduto.",
    "errorCause2": "Il link è stato modificato e non è più valido.",
    "errorContent": "Purtroppo non abbiamo potuto ricevere i vostri commenti. Le ragioni possono essere molteplici:",
    "header": "Mille grazie per i vostri commenti!",
    "success": "Il suo feedback ci aiuta a migliorare il nostro servizio."
  }
};